import { css } from '@emotion/css';

export const contentStyles = css`
  :last-of-type .content {
    border: none !important;
  }
  :hover .content {
    box-shadow: 0px -1px 0px 0px var(--bg-primary);
    border-color: var(--bg-primary);
  }
`;

export const disabledContentStyles = css`
  :last-of-type .content {
    border: none !important;
  }
`;
